import { initializeAppCheck, getToken, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { app } from './auth/firebase';
import { config } from './config';

let appCheckInstance: ReturnType<typeof initializeAppCheck> | null = null;

export function initAppCheck() {
  if (!config.appCheck.enabled || !config.appCheck.siteKey) return;

  // Debug token for local dev
  if (config.environment === 'dev') {
    (self as unknown as Record<string, unknown>).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  appCheckInstance = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(config.appCheck.siteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export async function getAppCheckToken(): Promise<string | null> {
  if (!appCheckInstance) return null;
  try {
    const result = await getToken(appCheckInstance, false);
    return result.token;
  } catch {
    return null; // Non-blocking, matches mobile pattern
  }
}
